import * as Yup from 'yup';
import { tokens } from '@shared/utils/i18n';
import { checkIban, KZ_IBAN_LENGTH } from '@shared/utils/helpers/validation/validateIban';

export const AccountSchema = Yup.object().shape({
  accountType: Yup.string().required(tokens.common.formFields.billType.validation.need),
  account: Yup.string()
    .min(KZ_IBAN_LENGTH, tokens.common.formFields.bill.validation.tooShort)
    .max(KZ_IBAN_LENGTH, tokens.common.formFields.bill.validation.error)
    // OSI-806: формат + контрольная сумма казахстанского IBAN (то же, что делает бэк
    // через [Iban] из IbanNet). Без этой проверки поле не подсвечивалось, «Сохранить»
    // не блокировалась, а ошибка прилетала общим тостом уже после запроса.
    // Пока длина не дотягивает до 20 — отдаём ход min/max, чтобы пользователь во время
    // набора видел «Счет указан не полностью», а не «Счет указан не верно».
    .test(
      'account-iban',
      () => tokens.common.formFields.bill.validation.error,
      (value) => !value || value.length !== KZ_IBAN_LENGTH || checkIban(value)
    )
    .required(tokens.common.formFields.bill.validation.need),
  bank: Yup.object().shape({
    bic: Yup.string()
      .min(8, tokens.common.formFields.IDNBank.validation.tooShort)
      .max(8, tokens.common.formFields.IDNBank.validation.error)
      .required(tokens.common.formFields.IDNBank.validation.need),
    name: Yup.string()
  })
});
